<template>
  <div class="cbg-white-container v-card border-card input-container theme--light">
    <div class="col-sm-12 row ml-0 pl-0 pr-0">
      <div class="form-group col-sm-3">
        <label for>Filter</label>
        <div class="search-div position-relative">
          <input
            type="text"
            placeholder="Search"
            class="form-control"
            v-model="searchLog"
            @input="throttledMethod"
          />
          <div v-if="searchLog !== ''" class="search-svg position-absolute" @click="clearSearch()">
            <crossSVG />
          </div>
        </div>
      </div>
    </div>
    <div class="table-div">
      <table class="table">
        <thead>
          <tr>
            <th>LOGS</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in logArray" :key="index">
          <tr @click="getItem(item)">
            <td>{{ item }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <CModal
      v-if="logSelected"
      :show.sync="logSelected"
      :no-close-on-backdrop="true"
      :centered="true"
      title="History"
      size="lg"
      color="dark"
    >
      <div class="col-sm-12">
        <div class="form-group">
          <!-- <p>
            <span class="font-weight-bold">Date:</span>
            {{ log.approvedOn }}
          </p>-->
          <p class="text-dark" style="white-space: pre-wrap;word-break: break-all;">{{ selectedLog}}</p>
          <hr />
        </div>
      </div>

      <template #header>
        <h6 class="modal-title">History</h6>
        <CButtonClose @click="logSelected = false" />
      </template>
      <template #footer>
        <CButton @click="logSelected = false" color="danger">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import _ from "lodash";
export default {
  name: "LogDetails",
  data() {
    return {
      logArray: [],
      selectedLog: "",
      logSelected: false,
      searchLog: "",
      cache: []
    };
  },
  mounted() {
    this.fetchLogs();
  },
  components: {
    ...pickSvg("crossSVG")
  },

  methods: {
    clearSearch() {
      this.searchLog = "";
    },
    getItem(item) {
      this.selectedLog = "";
      let url = `${config.TRANSPORT_URL}logs/${item}`;
      this.$http.get(url).then(response => {
        this.selectedLog = "";
        this.$nextTick(() => {
          this.selectedLog = response.bodyText;
          this.$forceUpdate();
        });
      });
      this.logSelected = true;
    },
    fetchLogs() {
      let url = `${config.TRANSPORT_URL}logs`;
      this.$http.get(url).then(response => {
        this.logArray = response.data;
        this.cache = this.logArray;
      });
    },
    throttledMethod: _.debounce(function(e) {
      if (this.searchLog) {
        let result = this.logArray.filter(item =>
          item.includes(this.searchLog)
        );
        if (result) {
          this.logArray = [];
          this.logArray = [...result];
        }
      } else {
        this.logArray = [...this.cache];
      }
    }, 1000)
  }
};
</script>
